/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { createSlice } from "@reduxjs/toolkit";
import { seoState } from "./seo.state"; 

const seo = createSlice({
    
    name: "seo",
    
    initialState: seoState,
    
    reducers: {
    
        setCurrentSeo (state, action) {
            const seo = action.payload;
            state.current = seo;
            state.byWebpageGUID[seo.webpage] = seo;
        },
    
    },
});

export const seoReducer = seo.reducer;

export const { setCurrentSeo } = seo.actions;
